import DOMPurify from "dompurify";

/**
 * Safely renders CMS HTML content. Falls back to `fallback` when body is
 * empty or when React is hydrating a value that hasn't loaded yet.
 */
export default function RichHtml({ html, fallback = null, className = "prose-tiob" }) {
  if (!html || !html.trim()) return fallback;
  const clean = DOMPurify.sanitize(html, {
    ADD_ATTR: ["target", "rel"],
  });
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
